<template>
  <div>
    <div class="container">
      <div class="row">
        <h2 class="col s12">{{ pageName }}</h2>
      </div>

      <div class="row clearfix">
        <div class="col-left-icon">
          <!-- <div class="col s1 m1 l1"> -->
          <object
            class="img-round margin-top-l"
            style="width: 70px; height: 70px;"
            :data="require('@/assets/images/layout/quaese.svg')"
            type="image/svg+xml"
          >
            <img
              class="img-round margin-top-l"
              src="@/assets/images/layout/quaese__50x50.png"
              alt="Quaese"
            />
          </object>
        </div>
        <div class="col-right-icon">
          <blockquote class="profile-list-blockquote">
            <!-- <blockquote class="col s11 m11 l11"> -->
            <h3>Steckbrief</h3>
            <ul class="profile-list">
              <li>
                <i class="material-icons small">{{ material_icon }}</i>
                <div class="profile-list-content">Name: Markus Höllein</div>
              </li>
              <li>
                <i class="material-icons small">{{ material_icon }}</i>
                <div class="profile-list-content">Nick: Quaese</div>
              </li>
              <li>
                <i class="material-icons small">{{ material_icon }}</i>
                <div class="profile-list-content">Alter: {{ age }} Jahre</div>
              </li>
              <li>
                <i class="material-icons small">{{ material_icon }}</i>
                <div class="profile-list-content">
                  Wohnort: Jena (Thüringen)
                </div>
              </li>
            </ul>
            <ul class="profile-list">
              <li>
                <i class="material-icons small">{{ material_icon }}</i>
                <div class="profile-list-content">
                  Schulabschluß: Allgemeine Hochschulreife
                </div>
              </li>
              <li>
                <i class="material-icons small">{{ material_icon }}</i>
                <div class="profile-list-content">
                  Hochschulabschluß: Diplom-Ingenieur (FH) Elektrotechnik
                  (Schwerpunkt Daten- und Informationstechnik)
                </div>
              </li>
              <li>
                <i class="material-icons small">{{ material_icon }}</i>
                <div class="profile-list-content">
                  Diplomarbeit: Entwicklung eines Vertriebsmoduls in
                  Notes/Domino
                </div>
              </li>
            </ul>
            <ul class="profile-list">
              <li>
                <i class="material-icons small">{{ material_icon }}</i>
                <div class="profile-list-content">
                  Kenntnisse Webentwicklung<br />(D)HTML, CSS, natives
                  JavaScript &amp; Ajax, JS-Frameworks, PHP, mySQL, Taskrunner
                  (Gulp, Grunt)
                </div>
              </li>
              <li>
                <i class="material-icons small">{{ material_icon }}</i>
                <div class="profile-list-content">
                  EDV-Kenntnisse<br />
                  MS-Office (Word, Excel, Powerpoint, VBA)<br />
                  Lotus/IBM (WordPro, Notes, Notes/Domino, LotusScript)<br />
                  Adobe Photoshop/Illustrator, Gimp, Ulead PhotoImpact,
                  Inkscape, Cinema4D
                </div>
              </li>
              <li>
                <i class="material-icons small">{{ material_icon }}</i>
                <div class="profile-list-content">
                  Entwicklungsumgebungen<br />Visual Studio (Visual Basic, C,
                  C++)
                </div>
              </li>
            </ul>
          </blockquote>
        </div>
      </div>
      <!-- .row -->
    </div>
  </div>
</template>

<script>
export default {
  name: "profile",

  data() {
    return {
      css: {
        cardLight: "grey lighten-5",
        cardLightColored: "blue-grey lighten-5"
      },
      pageName: "Steckbrief",
      material_icon: "check_box",
      age: new Date().getFullYear() - new Date(1968, 0, 4).getFullYear()
    };
  }
};
</script>

<style lang="less" scoped></style>
